import React, { useState } from "react";
import { Tile, Card, Media, Content, Level, Tag } from "react-bulma-components";
import { useRouter } from "next/router";
import Link from "next/link";

import { clipJobPreview, displayLocation } from "../../utils";
import JobStatsCard from "./JobStatsCard";
import { displayCurrency } from "../../utils";
import JobHeader from "./JobHeader";
import JobTags from "./JobTags";

const JobPreview = ({ job }) => {
  const [showFull, setShowFull] = useState(false);
  const router = useRouter();
  let descriptionShown;

  if (showFull) {
    descriptionShown = job.description;
  } else {
    descriptionShown = clipJobPreview(job.description);
  }

  return (
    <Card className="job">
      <Card.Content>
        <JobHeader job={job} showTags={true} showAdditional={true} />
      </Card.Content>
    </Card>
  );
};

export default JobPreview;

// export default createFragmentContainer(JobPreview, {
//   job: graphql`
//     fragment JobPreview_job on JobNode {
//       id
//       headline
//       company {
//         name
//         logo
//       }
//       expiry
//       description
//       location {
//         country
//       }
//       bounty
//       bountyCurrency
//       minSalary
//       maxSalary
//       salaryCurrency
//       tags {
//         name
//       }
//       ...JobHeader_job @relay(mask: true)
//       ...JobStatsCard_job @relay(mask: true)
//       ...JobTags_job @relay(mask: true)
//     }
//   `
// });
